
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talks/[...slug]",
      function () {
        return require("private-next-pages/talks/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talks/[...slug]"])
      });
    }
  